import { render } from "./ChangeSemesterSchoolyearDlalog.vue?vue&type=template&id=3d81f024"
import script from "./ChangeSemesterSchoolyearDlalog.vue?vue&type=script&lang=js"
export * from "./ChangeSemesterSchoolyearDlalog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__